import React from "react";
import SeoHead from "../../../components/SeoHead";
import PersonalHero from "./PersonalHero";
import PersonalNumbers from "./PersonalNumbers";
import PersonalPayments from "./PersonalPayments";
import PersonalSecurity from "./PersonalSecurity";
import Testimonial from "../Testimonial";
import Faq from "../Faq";
import PersonalFinances from "./PersonalFinances";

function Personal() {
  return (
    <div id="personal">
      <SeoHead title="Personal Finance" description="Manage your personal finances with Impala Digital Payments. Send payments, track expenses and stay on top of your money in real time." path="/personal" />
      <div className="bg-img-personal h-auto pt-[5rem]">
        <div className="lg:px-[5.69rem] px-3  lg:min-h-[47.125rem] min-h-auto ">
          <PersonalHero />
        </div>
      </div>

      <div className="bg-busines-type h-auto py-[3.06rem]">
        <div className="lg:px-[5.69rem] px-3 ">
          <PersonalNumbers />
        </div>
      </div>

      <div className="lg:px-[5.69rem] px-3  lg:py-[6.5rem] py-[3rem]">
        <PersonalPayments />
      </div>

      <div className="lg:px-[5.69rem] px-3 lg:mt-[5.03rem] mt-[2rem] py-[2.75rem] bg-dark shadow-[0_0_0_1px_rgba(0,0,0,0.05)]">
        <PersonalSecurity />
      </div>

      <div className="lg:px-[5.69rem] px-3 mt-[4.12rem] bg-white">
        <Testimonial />
      </div>

      <div className="bg-busines-type impala-corners h-auto lg:pt-[8.44rem] py-3">
        <div className="lg:px-[5.69rem] px-3 ">
          <Faq />
        </div>
      </div>

      <PersonalFinances/>

    </div>
  );
}

export default Personal;
